export class windowHistoryService {
    // the url a kiosk terminal has to keep in its address bar: after a restart it is the only
    // thing that still knows the location, so it must not be replaced with a bare "/". the mode
    // is in it as well, so the url alone brings a terminal back up on a wiped browser profile
    public static kioskUrl(code: string) {
        return `/${code}?mode=kiosk`;
    }

    public static pushState(state: any, url: string) {
        if (window.history?.pushState) {
            window.history.pushState(state, "", url);
        }
    }

    public static getDirectLinkCodeFromUrlOrHistory(): string | undefined {
        //its so delecate, check for all null and undefines
        if (
            window.history !== undefined &&
            window.history != null &&
            window.history.state !== undefined &&
            window.history.state != null &&
            window.history.state.permalinkReferrer !== undefined &&
            window.history.state.permalinkReferrer != null
        )
            return window.history.state.permalinkReferrer;

        const g = location.pathname.match(/(?:\/)?([a-zA-Z0-9]{6})$/);
        if (g == null) return undefined;

        if (g.length === 2) return g[1];

        return undefined;
    }
}
